import { pathOr, difference, isEmpty } from 'rambda';
import { filter, map } from 'fp-ts/Array';
import { pipe } from 'fp-ts/function';
import { ICert } from '.';

export const certsAllSelected = ({
  certs,
  selectedKeys,
}: {
  certs: ICert[];
  selectedKeys: string[];
}) =>
  pipe(
    certs,
    map<ICert, string>(pathOr('', 'key')),
    a => difference(a, selectedKeys),
    isEmpty
  ) && !isEmpty(certs);

export const excludeUserRoles = (keys: string[]) =>
  filter<ICert>(({ key }) => keys.indexOf(key) === -1);
